module.exports = __webpack_public_path__ + "img/pasos-de-uso.946d3932.svg";